import React, { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Input,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import ReactSelect from "react-select";
// Date picker
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Common components
// import CommonCheckbox from "../../../components/common/checkbox/checkbox";
// Maintenance components
import MaintenanceForm from "../../../components/maintenance/form/form";
// Components
import Upload from "../../../components/upload/upload";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as pushNotificationsActions from "../../../redux/actions/pushNotifications";
import * as filesActions from "../../../redux/actions/files";
// Utils
import { 
  formatPushNotificationActions, 
} from "../../../utils/formatters";
// Styles
import "./form.css";

// Vars
registerLocale('es', es)

const PushNotificationsForm = ({ isNew }) => {
  const dispatch = useDispatch();
  const childRef = useRef();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    "enabled": true,
  });
  const [isDirty, setIsDirty] = useState(false);
  const [isDirtyFiles, setIsDirtyFiles] = useState(false);
  const [files_1, setFiles_1] = useState([]);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);

  // Set constants
  const page = "push_notifications";
  const primaryName = !isNew && !!form[`title`] ? form[`title`] : ``;
  const itemNameSingular = "Notificació push";

  // Get id from url
  let id = null;
  const { id: paramId } = useParams();
  if (!isNew) {
    id = parseInt(paramId);
  }

  useEffect(() => {
    if (!!currentPage) return;

    // Set active page
    dispatch(mainActions.setCurrentPage(page));

    // Set initial breadscrum
    if (isNew) {
      const pathKey = 'new';
      const path = `${page}/${pathKey}`;
      dispatch(mainActions.setBreadscrum(page, [{ path, pathKey: 'new-m', itemNameSingular, }]));
    } else {
      const pathKey = 'edit';
      const path = `${page}/${pathKey}/${id}`;
      dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, itemNameSingular, }]));
    }
  }, []);

  const handleChange = (evt) => {
    if (childRef.current) {
      childRef.current.handleChange(evt);
    }
  };

  const renderForm = () => {
    return (
      <div className="push-notifications-form-wrapper">
        <div className="push-notifications-form-firstcolumn-wrapper">
          {renderMainCard()}
        </div>
        <div className="maintenance-form-card">
          {renderUploadCard_1()}
        </div>
      </div>
    );
  };

  const renderMainCard = () => {
    let title;
    if (isNew) {
      title = "Nova Notificació push";
    } else {
      title = `Notificació push${!!form[`id`] ? ` amb Id: ${form[`id`]}` : ''}`;
    }

    // Set options for combo
    const options = [
      { label: formatPushNotificationActions('open-news'), value: 'open-news'},
    ]; 

    return (
      <div className="push-notifications-form-maincard">
        <div className="title maintenance-form-title">
          {title}
        </div>  
        {/* IMPORTANT !!! Els checkboxes no poden estar en el mateix FormControl En producció no funciona!! */}
        {/* <CommonCheckbox
          isChecked={!!form['enabled']}
          onChange={(e) => {
            setForm({
              ...form,
              "enabled": e.target.checked,
            });     
            setIsDirty(true);         
          }}
        >
          Habilitat
        </CommonCheckbox>             */}
        <FormControl isRequired mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Títol
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="Títol"
            name="title"
            data-type={`string`}
            onChange={handleChange}
            value={form[`title`] ? form[`title`] : ``}
          />
        </FormControl>           
        <FormControl isRequired mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Descripció
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="Descripció"
            name="body"
            data-type={`string`}
            onChange={handleChange}
            value={form[`body`] ? form[`body`] : ``}
          />
        </FormControl>     
        {/* <Box 
          display="flex" 
          flexDirection="row" 
          gap={4}
        >
          <FormControl mt={4} isRequired w="150px" >
            <FormLabel fontSize="sm" className="maintenance-form-label">
              Data llançament
            </FormLabel>
            <DatePicker 
                locale="es"
                dateFormat="dd/MM/yy"             
                selected={!!form[`date`] ? new Date(form[`date`]) : ''} 
                // onSelect={(date) => {                           
                // }} //when day is clicked
                onChange={(date) => { 
                    handleChange({
                      isDate: true, 
                      onlyDate: true,
                      fieldName: 'date', 
                      value: date,
                    })            
                }} 
                customInput={
                  <Input
                    className="maintenance-form-field"
                    textAlign="center"
                  />
                }
                placeholderText="Data" 
                className="custom-datepicker"
                portalId="root-portal" // Esto forzará el renderizado en el portal
                popperPlacement="bottom-start" // Ajusta la posición del calendario
                disabled={false}
            />
          </FormControl>
          <FormControl isRequired w="150px" mt={4} >
            <FormLabel fontSize="sm" className="maintenance-form-label">
              Hora
            </FormLabel>
            <Input
              className="maintenance-form-field"z
              placeholder="Hora"
              name="time"
              data-type={`string`}
              onChange={handleChange}
              value={form[`time`] ? form[`time`] : ``}
              w="120px"
              textAlign="center"
              maxLength={5}
            />
          </FormControl>           
        </Box> */}
        <Box 
          display="flex" 
          flexDirection="row" 
          gap={4}
        >      
          <FormControl mt={4}>
            <FormLabel fontSize="sm" className='maintenance-form-label'>
                Acció
            </FormLabel>
            <ReactSelect
              className="maintenance-form-combo"
              classNamePrefix="react-select"
              name="action"
              options={options}
              isSearchable
              isClearable
              value={options.find(opt => opt.value === form["action"]) || null}
              onChange={(selectedOption) => {
                  setForm(prev => ({
                      ...prev,
                      action: selectedOption ? selectedOption.value : null
                  }));
                  setIsDirty(true);
              }}
              placeholder="Acció"
            />
          </FormControl>             
          <FormControl mt={4}>
            <FormLabel fontSize="sm" className="maintenance-form-label">
              Referència Id per l'acció
            </FormLabel>
            <Input
              className="maintenance-form-field"
              placeholder="Id"
              name="action_reference_id"
              data-type={`integer`}
              onChange={handleChange}
              value={form[`action_reference_id`] ? form[`action_reference_id`] : ``}
              inputMode="numeric"
            />
          </FormControl>   
        </Box>
      </div>   
    );
  };

  const renderUploadCard_1 = () => {
    return (
      <div className="push-notifications-form-upload-card">
        <FormControl>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Imatge
          </FormLabel>    
          {/* <Input
            className="maintenance-form-field"
            placeholder="https://"
            name="url_image_1"
            data-type={`string`}
            type="url"
            onChange={handleChange}
            value={form[`url_image_1`] ? form[`url_image_1`] : ``}
          /> */}
        </FormControl>            
        <Upload 
          type={"push_notification"}
          id={id}
          id2={"1"}
          style={{ marginTop: "10px"}}
          onChange={(files) => {
            setFiles_1(files);        
          }}      
          onNewFile={(newFiles) => {
            setIsDirty(true);
            setIsDirtyFiles(true);
          }}           
          onDeleteFile={(file) => {
            setIsDirty(true);
            setIsDirtyFiles(true);
          }}           
          onUpdateFile={(file) => {
            setIsDirty(true);
            setIsDirtyFiles(true);
          }} 
        />
      </div>
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="push-notifications-form-content">
        <MaintenanceForm 
          primaryKey={"id"}
          primaryValue={id}
          primaryName={primaryName}
          config={{
            submitFields: [ 
              `title`,
              `body`,
              `date`,
              `time`,
              `action`,
              `action_reference_id`,
              `url_image_1`,
              `enabled`,
            ],
          }}
          menuConfig={{}}
          itemNameSingular={itemNameSingular}
          itemIsMale={false}
          actions={pushNotificationsActions} 
          setIsLoading={setIsLoading}
          renderForm={renderForm}
          form={form}
          setForm={setForm}
          isDirty={isDirty}
          setIsDirty={setIsDirty}
          ref={childRef}
          isNew={isNew}
          page={"push_notifications"}
          executeAfterSaving={async (theId) => {
            return new Promise((resolve) => {
              if (!isDirtyFiles) {
                resolve({ success: true });
              }
              dispatch(filesActions.setFiles("push_notification", theId, "1", files_1)).then(
                () => {
                  resolve({ success: true });
                },
                (err) => resolve({ success: false, msg: err })
              );
            });
          }}
          alterDataFormBeforeSaving={(dataform) => {
            if (!dataform['action_reference_id']) {
              dataform['action_reference_id'] = 0;
            }
          }}
        />
      </div>
    </MainLayout>
  );
};

export default PushNotificationsForm;
